import { Suspense, useEffect } from "react";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { theme } from "../redux/customise/customiseActions";
import {
  BrowserRouter,
  Route,
  Switch,
  Redirect,
  useHistory,
} from "react-router-dom";

import { Routes } from "./routes";

import VerticalLayout from "../layout/VerticalLayout";

import Error404 from "../view/pages/errors/404";
import Agents from "pages/agents";
import { getFromLocalStorage } from "helpers/localstorage";
import Login from "view/pages/authentication-modern/login";

export default function Router() {
  const customise = useSelector((state) => state.customise);
  const dispatch = useDispatch();
  const location = useHistory();
  let themeLocal;

  useEffect(() => {
    if (localStorage) {
      themeLocal = localStorage.getItem("theme");
    }

    if (themeLocal === "light" || themeLocal === "dark") {
      document.querySelector("body").classList.add(themeLocal);
      dispatch(theme(themeLocal));
    } else {
      document.querySelector("body").classList.add(customise.theme);
      dispatch(theme(customise.theme));
    }
  }, [dispatch, customise.theme]);

  useEffect(() => {
    if (location.location.search === "?theme=dark") {
      localStorage.setItem("theme", "dark");
      themeLocal = "dark";
    } else if (location.location.search === "?theme=light") {
      localStorage.setItem("theme", "light");
      themeLocal = "light";
    }
  }, [location.location.search]);

  const isUserLoggedIn = () => {
    return !!getFromLocalStorage("token");
  };

  const LayoutRoutesAndPaths = () => {
    const LayoutRoutes = [];
    const LayoutPaths = [];
    Routes.forEach((route) => {
      if (!route.hide) {
        LayoutRoutes.push(route);
        LayoutPaths.push(route.path);
      }
    });
    return { LayoutRoutes, LayoutPaths };
  };

  const ResolveRoutes = () => {
    const { LayoutRoutes, LayoutPaths } = LayoutRoutesAndPaths();

    return (
      <Route path={LayoutPaths}>
        {isUserLoggedIn() ? (
          <VerticalLayout>
            <Switch>
              {LayoutRoutes.map((route) => (
                <Route
                  key={route.path}
                  path={route.path}
                  exact={route.exact === true}
                  render={(props) => (
                    <Suspense fallback={null}>
                      <motion.div
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{
                          type: "spring",
                          duration: 0.5,
                          delay: 0.5,
                        }}
                      >
                        <route.component {...props} />
                      </motion.div>
                    </Suspense>
                  )}
                />
              ))}
            </Switch>
          </VerticalLayout>
        ) : (
          <Redirect to="/login" />
        )}
      </Route>
    );
  };

  return (
    <BrowserRouter>
      <Switch>
        <Route
          exact
          path="/"
          render={() =>
            isUserLoggedIn() ? (
              <VerticalLayout>
                <Agents />
              </VerticalLayout>
            ) : (
              <Redirect to="/login" />
            )
          }
        />

        <Route
          path="/login"
          render={() => (isUserLoggedIn() ? <Redirect to="/" /> : <Login />)}
        />

        {ResolveRoutes()}

        <Route path="*">
          <Error404 />
        </Route>
      </Switch>
    </BrowserRouter>
  );
}
